import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from "react-redux";

import './App.css';

import store from './store';
import { Routers } from './routers';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { CartProvider } from './cart/CartContext';
import { CatalogProvider } from './catalog/CatalogContext';
import ScrollToTop from './routers/ScrollToTop';


function App() {
  return (
    <Provider store={store}>
      <CatalogProvider>
        <CartProvider>
          <Router>
            <div className="App app-shell">
              <ScrollToTop />
              <Header />
              <main className="page-shell">
                <Routers />
              </main>
              <Footer />
            </div>
          </Router>
        </CartProvider>
      </CatalogProvider>
    </Provider>
  );
};

export default App;
